import { HttpClient } from './HttpClient'
const authApiBaseUrl = window.location.origin
const claimsApiBaseUrl = window.location.origin
const registryApiBaseUrl = window.location.origin
const userApiBaseUrl = window.location.origin
const miscApiBaseUrl = window.location.origin
const memberApiBaseUrl = window.location.origin
const patientApiBaseUrl = window.location.origin
const blockchainApiBaseUrl = window.location.origin
const productsApiBaseUrl = window.location.origin

const getAxiosClientOptions = (url: string) => {
    const accessToken = localStorage.getItem('access_token')
    const options = {
        baseURL: url,
        timeOut: 30000,
        headers: {} as object,
        adapter: require('axios/lib/adapters/http'),
    }

    if (accessToken !== null) {
        options.headers = { Authorization: `Bearer ${accessToken}` }
    }
    return options
}

export const authApiClient = new HttpClient(getAxiosClientOptions(authApiBaseUrl))
export const claimsApiClient = new HttpClient(getAxiosClientOptions(claimsApiBaseUrl))
export const registryApiClient = new HttpClient(getAxiosClientOptions(registryApiBaseUrl))
export const userApiClient = new HttpClient(getAxiosClientOptions(userApiBaseUrl))
export const miscApiClient = new HttpClient(getAxiosClientOptions(miscApiBaseUrl))
export const memberApiClient = new HttpClient(getAxiosClientOptions(memberApiBaseUrl))
export const patientApiClient = new HttpClient(getAxiosClientOptions(patientApiBaseUrl))
export const blockchainApiClient = new HttpClient(getAxiosClientOptions(blockchainApiBaseUrl))
export const productsApiClient = new HttpClient(getAxiosClientOptions(productsApiBaseUrl))
